export enum TaskTodoSubtype {
  LinkedinInvitation = 'LinkedinInvitation',
  LinkedinMessage = 'LinkedinMessage',
  LinkedinVoiceNote = 'LinkedinVoiceNote',
  LinkedinProfileView = 'LinkedinProfileView',
  LinkedinLikeLastPost = 'LinkedinLikeLastPost',
}
